import { IUpdateConfigurationPayload } from '../../_models/superAdmin/configurationInterface'
import { get, put } from '../apiServices'

export const getSuperAdminConfigurationDetails = async () => {
  const response = await get('super-admin/settings')
  return response
}

export const updateSuperAdminConfigurationDetails = async (params: IUpdateConfigurationPayload) => {
  const response = await put('super-admin/settings', params)
  return response
}
